import { Button } from "primereact/button";

interface WizardStepConnectProps {
  deviceName?: string | null;
  processing: boolean;
  loading: boolean;
  isConnected: boolean;
  onConnect: () => void;
  onContinue: () => void;
  onBack: () => void;
}

export function WizardStepConnect({
  deviceName,
  processing,
  loading,
  isConnected,
  onConnect,
  onContinue,
  onBack,
}: WizardStepConnectProps) {
  return (
    <div className="p-fluid">
      <div className="p-field">
        <h3>Connect to Device</h3>
        {deviceName ? (
          <>
            <p>
              Device found: <strong>{deviceName}</strong>
            </p>
            <p>
              {isConnected
                ? "Device is connected. Continue to configure WiFi."
                : "Click the button below to connect to the device."}
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginTop: "24px",
              }}
            >
              {isConnected ? (
                <Button
                  label="Continue"
                  icon="pi pi-arrow-right"
                  onClick={onContinue}
                  disabled={processing || loading}
                  className="p-button-primary"
                  style={{ width: "100%", marginBottom: "10px" }}
                />
              ) : (
                <Button
                  label="Connect"
                  icon="pi pi-link"
                  onClick={onConnect}
                  disabled={processing || loading}
                  className="p-button-primary"
                  style={{ width: "100%", marginBottom: "10px" }}
                />
              )}
              <Button
                label="Back"
                icon="pi pi-arrow-left"
                onClick={onBack}
                className="p-button-secondary"
                disabled={processing || loading}
                style={{ width: "100%" }}
              />
            </div>
          </>
        ) : (
          <>
            <p>No device found. Please go back and scan again.</p>
            <div style={{ marginTop: "24px" }}>
              <Button
                label="Back"
                icon="pi pi-arrow-left"
                onClick={onBack}
                className="p-button-secondary"
                disabled={processing || loading}
                style={{ width: "100%" }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
